import {all, put, select, take, takeEvery} from "redux-saga/effects";
import {ActionType, getType} from "typesafe-actions";
import {actuallyShowDialog, closeDialog, showDialog} from "./actions";
import {AnyAction} from "redux";
import {IApplicationState} from "../index";
import forkWithErrHandler from "../../shared/utils/forkWithErrHandler";
import loadAndShowQuestion from "../game/sagas/loadAndShowQuestion";

function* watchShowDialog() {
    yield takeEvery(getType(showDialog), function* ({ payload }: ActionType<typeof showDialog>) {
        const currentDialog = yield select(({ dialogs }: IApplicationState) => dialogs.currentDialog);
        if (currentDialog) {
            yield take(closeDialog);
        }

        yield put(actuallyShowDialog(payload));
        yield take(closeDialog);
    });
}

function* watchQuestionDialog() {
    while (true) {
        const { payload: { options: { questionId } } }: ActionType<typeof showDialog> = yield take((action: AnyAction) => {
            return action.type === getType(showDialog)
                && action.payload.type === "QuestionDialog";
        });

        yield loadAndShowQuestion(questionId);

        yield put(closeDialog(undefined));
    }
}

export default function* dialogManagerSaga() {
    yield all([
        forkWithErrHandler("dialogManagerSaga", "watchShowDialog", watchShowDialog),
        forkWithErrHandler("dialogManagerSaga", "watchQuestionDialog", watchQuestionDialog),
    ]);
}